import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { UtilityService } from 'src/api/utility.service';

@Component({
  selector: 'app-static-summary-data',
  templateUrl: './static-summary-data.component.html',
  styleUrls: ['./static-summary-data.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule]
})
export class StaticSummaryDataComponent implements OnInit {
  @Input()
  sectionData: any;

  @Input()
  singleSectionCardData: any;

  @Input()
  singleRow: any;

  constructor(public utilityService: UtilityService) {}

  ngOnInit(): void {
  }
}
